/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */
import {
  APP_BASE_HREF,
  PathLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "./@theme/theme.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthModule } from "./@auth/auth.module";
import { OwlModule } from "ngx-owl-carousel";

import { LoginComponent } from "./@theme/components/login/login.component";
import { RegisterComponent } from "./@theme/components/register/register.component";
import { TermsComponent } from "./@theme/components/terms/terms.component";
import { PolicysComponent } from "./@theme/components/policys/policys.component";

import { ConfigService } from "./pages/projects/common/config.service";
import { NgxPrintModule } from "ngx-print";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    TermsComponent,
    PolicysComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    AuthModule.forRoot(),
    CoreModule.forRoot(),
    OwlModule,
    NgxPrintModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    ConfigService,
    // { provide: APP_BASE_HREF, useValue: '/' },
  ],
})
export class AppModule {}
